import React, { Dispatch, SetStateAction } from 'react'
import classNames from 'classnames'
import { FormattedCurrency } from '@dustin-web/microsite-components/src/i18n'
import { NumberBadge } from '@dustin-web/microsite-components/src/badge'
import { default as ShoppingCartIcon5 } from '@dustin-web/microsite-components/src/icon/generated/shopping-cart-5'
import { ProductDigitalData } from '@dustin-web/product-components/src/utils/product-digital-data'
import { CartItemFragment } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import Spinner from '@dustin-web/microsite-components/src/spinner'

type CommonProps = {
  cartIsEmpty: boolean
  totalQuantity: number
  isLoading: boolean
}

export function MobileButton({ cartIsEmpty, totalQuantity, isLoading }: CommonProps) {
  if (isLoading) {
    return (
      <div className="u-relative u-w-24 c-header__user-btn c-header__user-btn--minicart">
        <Spinner local size="xxs" />
      </div>
    )
  }
  return (
    <a
      data-ga-title="minicart"
      className="button-stripped u-relative d-block u-mb-0 u-mr-0"
      style={{ fontSize: 0 }}
      href="/shoppingcart">
      <ShoppingCartIcon5 name="shopping-cart-5" className="i-24" />
      {!cartIsEmpty && (
        <NumberBadge
          data-test-id="mini-cart-product-count"
          show={!cartIsEmpty}
          quantity={totalQuantity}
          className={classNames('u-bg-red u-color-white c-header__badge', {
            'c-header__badge--large-quantity': totalQuantity > 99,
          })}
        />
      )}
    </a>
  )
}
type DesktopButtonProps = CommonProps & {
  setShowDrawer: Dispatch<SetStateAction<boolean>>
  cartItems: CartItemFragment[]
  totalPrice: number
  text: string
  isLoading: boolean
}
export function DesktopButton({
  setShowDrawer,
  cartItems,
  cartIsEmpty,
  totalPrice,
  totalQuantity,
  text,
  isLoading,
}: DesktopButtonProps) {
  if (isLoading) {
    return (
      <div className="c-header__user-btn">
        <span className="c-minicart__icon c-header__user-icon c-header__user-icon--minicart">
          <ShoppingCartIcon5 name="shopping-cart-5" className="i-20" />
        </span>
        <div className="u-relative u-w-56">
          <Spinner local size="xxs" />
        </div>
      </div>
    )
  }

  return (
    <button
      data-ga-title="minicart"
      className="c-header__user-btn c-header__user-btn--minicart button-stripped u-mr-0 u-mb-0"
      onClick={(e: any) => {
        e.preventDefault()
        ProductDigitalData.pushEventWithCartItems('view_minicart', cartItems)
        setShowDrawer(show => !show)
      }}>
      <span className="c-minicart__icon c-header__user-icon c-header__user-icon--minicart">
        <ShoppingCartIcon5 name="shopping-cart-5" className="i-20" />
      </span>
      <span
        className={classNames('c-minicart__price-title c-header__user-title', {
          'u-fw-bold': !cartIsEmpty,
          'u-fw-normal': cartIsEmpty,
        })}>
        {!cartIsEmpty ? (
          <strong>
            <FormattedCurrency amount={totalPrice} />
          </strong>
        ) : (
          text
        )}
      </span>
      <NumberBadge
        data-test-id="mini-cart-product-count"
        show={!cartIsEmpty}
        quantity={totalQuantity}
        className={classNames('u-bg-red u-color-white c-header__badge', {
          'c-header__badge--large-quantity': totalQuantity > 99,
        })}></NumberBadge>
    </button>
  )
}
